import * as React from 'react'
import * as E from 'fp-ts/lib/Either'

import { LocalTime } from '@espoon-voltti/ts-libs/lib/time'
import {
  Input,
  InputProps
} from '@espoon-voltti/react-components/elements/form'

interface Props extends Omit<InputProps, 'onChange' | 'value'> {
  onChange: (value: LocalTime) => void
  value: LocalTime | null
}

export const TimeInput = (p: Props) => {
  const { value, onChange, ...inputProps } = p
  const [state, setState] = React.useState<string>(
    value ? value.format('fi') : ''
  )

  const handleBlur = (e: any) => {
    const maybeValid = LocalTime.parse(e.target.value)
    if (E.isRight(maybeValid)) {
      setState(maybeValid.right.format('fi'))
      p.onChange(maybeValid.right)
    } else {
      setState(value ? value.format('fi') : '')
    }

    if (p.onBlur) {
      p.onBlur(e)
    }
  }

  // select input value when starting to type
  // ..for example there is a zero present, this will prevent preceding zeroes from being
  // inputted unintentionally
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select()

    if (p.onFocus) {
      p.onFocus(e)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const candidate = e.target.value.trim()
    setState(candidate)
  }

  return (
    <Input
      {...inputProps}
      type="text"
      value={state}
      onBlur={handleBlur}
      onFocus={handleFocus}
      onChange={handleChange}
    />
  )
}
